export interface File {
  name: string;
}
